import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, imgUrl } from "@/lib/api";
import { useSeo } from "@/lib/shop";
import { GridSkeleton, Empty } from "@/components/site/States";

const COLORS = ["#ffc400", "#ff7a00", "#1d4fa8", "#e8251f", "#111111", "#16a34a", "#7c3aed"];

export default function Categories() {
  useSeo("Kategori Produk", "Jelajahi kategori Gunpla, figure, diecast, Blokees, TCG, Beyblade, dan aksesoris.");
  const { data, isLoading } = useQuery({ queryKey: ["categories"], queryFn: () => api.get("/categories").then((r) => r.data) });
  return (
    <div className="container-x py-10" data-testid="categories-page">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold">Kategori Produk</h1>
      <p className="text-neutral-600 mt-2">Pilih kategori untuk melihat koleksi Ready Stock dan Pre-Order.</p>
      <div className="mt-8">
        {isLoading ? <GridSkeleton n={6} /> : !data?.length ? <Empty title="Belum ada kategori" /> : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {data.map((c, i) => (
              <Link key={c.id} to={`/kategori/${c.slug}`} data-testid={`categories-card-${c.slug}`} className="group sticker sticker-hover rounded-2xl overflow-hidden bg-white">
                <div className="aspect-[4/3] overflow-hidden" style={{ background: COLORS[i % COLORS.length] }}>
                  {c.image && <img src={imgUrl(c.image)} alt={c.name} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                </div>
                <div className="p-4 border-t-2 border-neutral-900">
                  <div className="font-heading font-bold">{c.name}</div>
                  <div className="text-xs text-neutral-500 mt-1">{c.product_count} produk</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
